import gql from 'graphql-tag';
import * as i0 from "@angular/core";
import * as i1 from "../shared/services/graph-qlclient.service";
export class VendedorRubroClienteService {
    constructor(gqlclient) {
        this.gqlclient = gqlclient;
    }
    GetByCliente(inputData, callback) {
        const inputParams = this.createInputParamsGetByCliente(inputData);
        this.executeQueryObtenerSegunFiltroRubroeIPT(inputParams, callback);
    }
    GetAllVendedores(inputData, callback) {
        const inputParams = this.createInputParamsGetVendedores(inputData);
        this.executeQueryObtenerSegunFiltro(inputParams, callback);
    }
    // FV: Lo hago a modo de limpiar la data de parámetros innecesarios y para direccionar la query en pro del contexto
    createInputParamsGetByCliente({ rutEmpresa, sucursalCodigo, rutCliente, direccionCodigo }) {
        return {
            rutEmpresa,
            sucursalCodigo,
            rutCliente,
            direccionCodigo,
        };
    }
    createInputParamsGetVendedores({ rutEmpresa, sucursalCodigo }) {
        return {
            rutEmpresa,
            sucursalCodigo
        };
    }
    executeQueryObtenerSegunFiltroRubroeIPT(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
        query(
          $rutEmpresa: Decimal
          $sucursalCodigo: Decimal
          $rutCliente: Decimal
          $direccionCodigo: Decimal
        ) {
          vendedor_rubro_cliente {
            obtenerSegunFiltroRubroeIPT(
              filtro: {
                exacto: {
                  rut_empresa: $rutEmpresa
                  sucursal_codigo: $sucursalCodigo
                  cliente_proveedor_rut: $rutCliente
                  direccion_codigo: $direccionCodigo
                  vendedor_codigo: -1
                  rubro_codigo: -1
                }
              }
            ) {
              respuesta {
                registros {
                  cliente_proveedor_rut
                  direccion_codigo
                  lunes
                  martes
                  miercoles
                  jueves
                  viernes
                  sabado
                  domingo
                  es_cobrador
                  nombreRubro
                  nombreVendedor
                  realiza_cobro_maquina
                  rubro_codigo
                  vendedor_codigo
                  listaUnidadNegocio
                }
              }
            }
          }
        }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { respuesta } = response.data.vendedor_rubro_cliente.obtenerSegunFiltroRubroeIPT;
            if (!respuesta) {
                callback(null);
                return;
            }
            const { registros } = respuesta;
            callback({ registros });
        });
    }
    executeQueryObtenerSegunFiltro(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
        query ($rutEmpresa: Decimal, $sucursalCodigo: Decimal) {
          vendedor {
            obtenerSegunFiltro(filtro: {exacto: {rut_empresa: $rutEmpresa, sucursal_codigo: $sucursalCodigo, tipobusqueda: 1}}) {
              mensajes {
                codigo
                contexto
                texto
              }
              respuesta {
                registros {
                  codigo
                  rut_empresa
                  sucursal_codigo
                  nombre
                  rut
                }
              }
            }
          }
        }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { respuesta } = response.data.vendedor.obtenerSegunFiltro;
            if (!respuesta) {
                callback(null);
                return;
            }
            const { registros } = respuesta;
            callback({ registros });
        });
    }
}
VendedorRubroClienteService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function VendedorRubroClienteService_Factory() { return new VendedorRubroClienteService(i0.ɵɵinject(i1.GraphQLClient)); }, token: VendedorRubroClienteService, providedIn: "root" });
